import Image from "next/legacy/image";

const tiers = [
    {name: 'Pay with Points', icon: '/assets/images/club-member/tiers/icon-1.svg', description: '', regular: 1, elite: 1},
    {name: 'Regular Discounts', icon: '/assets/images/club-member/tiers/icon-2.svg', description: '', regular: 1, elite: 1},
    {name: 'Exclusive Promos', icon: '/assets/images/club-member/tiers/icon-3.svg', description: '', regular: 1, elite: 1},
    {name: 'Free Towing', icon: '/assets/images/club-member/tiers/icon-4.svg', description: '', regular: 0, elite: 1},
    {name: 'Promo Notifications', icon: '/assets/images/club-member/tiers/icon-5.svg', description: '', regular: 1, elite: 1},
    {name: 'Service History', icon: '/assets/images/club-member/tiers/icon-6.svg', description: '', regular: 0, elite: 1},
    {name: 'Referral Points', icon: '/assets/images/club-member/tiers/icon-7.svg', description: '', regular: 0, elite: 1},
    {name: 'Exclusive Online Community', icon: '/assets/images/club-member/tiers/icon-8.svg', description: '', regular: 1, elite: 1},
];

export default function Tiers(){
    return(
        <section id="tiers" className='lg:scroll-mt-[150px] md:scroll-mt-[140px] sm:scroll-mt-[130px] scroll-mt-[80px] snap-normal snap-start w-full bg-white md:pt-12 pt-4 border-t border-gray-200'>
            <div className='max-w-screen-xl mx-auto md:px-12 px-4'>
                <h1 className='text-5xl text-center pb-4'>Save And Experience The Rapide Way!</h1>
                <h1 className='text-xl text-center'>Compare all tiers</h1>
                <div className='w-full py-4'>
                    <Image
                        alt={'tiers-1'}
                        src={'/assets/images/club-member/tier-updated-1.webp'}
                        layout="responsive"
                        height={1000}
                        width={1000}
                        objectFit="contain"
                    />
                </div>
                {/*<div className='invisible grid grid-cols-1 gap-4 py-8'>
                    <div className='grid grid-cols-3 gap-2'>
                        <div style={{boxShadow: '0px 0px 20px #f1f1f1'}} className='relative rounded-3xl col-start-2'>
                            <Image
                                alt='rapide-club'
                                src={'/assets/images/club-member/regular.webp'}
                                layout="responsive"
                                height={600}
                                width={1000}
                                objectFit="contain"
                            />
                        </div>
                        <div style={{boxShadow: '0px 0px 20px #f1f1f1'}} className='relative rounded-3xl'>
                            <Image
                                alt='rapide-club'
                                src={'/assets/images/club-member/elite.webp'}
                                layout="responsive"
                                height={600}
                                width={1000}
                                objectFit="contain"
                            />
                        </div>
                    </div>
                    {tiers.map((tier, index) => {
                        return(
                            <div key={index} className='grid grid-cols-3 gap-2'>
                                <div className='flex flex-row flex-wrap items-center align-middle justify-start'>
                                    <div className='relative sm:w-24 sm:h-24 w-14 h-14'>
                                        <Image
                                            alt={tier.name}
                                            src={tier.icon}
                                            layout="responsive"
                                            height={1000}
                                            width={1000}
                                            objectFit="contain"
                                        />
                                    </div>
                                    <h1 className='ml-4 text-xl font-bold align-middle'>{tier.name}</h1>
                                </div>
                                <div className='sm:w-24 sm:h-24 w-14 h-14 mx-auto'>
                                    <Image
                                        alt={'reg-icon'}
                                        src={tier.regular == 1 ? '/assets/images/club-member/check-icon.webp' : '/assets/images/club-member/x-icon.webp'}
                                        layout="responsive"
                                        height={1000}
                                        width={1000}
                                        objectFit="contain"
                                    />
                                </div>
                                <div className='sm:w-24 sm:h-24 w-14 h-14 mx-auto'>
                                    <Image
                                        alt={'elite-icon'}
                                        src={tier.elite == 1 ? '/assets/images/club-member/check-icon.webp' : '/assets/images/club-member/x-icon.webp'}
                                        layout="responsive"
                                        height={1000}
                                        width={1000}
                                        objectFit="contain"
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>*/}
            </div>
        </section>
    );
}